import { environment } from "../../../environments/environment";

export class FraudnetData {
  token: string;
  ip: string;
  bin: string;
  headers: any = {};

  constructor(fraudnetData?: any) {
    if (fraudnetData) {
      this.token = fraudnetData.token;
      this.ip = fraudnetData.ip;
      this.bin = fraudnetData.bin;
    }

    this.getRequestHeaders();
  }

  private getRequestHeaders() {
    this.headers.userAgent = window.navigator.userAgent.toLowerCase();
    this.headers["content-type"] = "application/json";
    this.headers["accept"] = "application/json, text/plain, */*";
    this.headers["accept-language"] = "pt-BR,pt;q=0.9,en-US;q=0.8,en;q=0.7,fr;q=0.6";
    this.headers["accept-encoding"] = "gzip, deflate, br";
    this.headers["authorization"] = "Bearer " + environment.api_authorization_token;
    this.headers["origin"] = window.location.origin;
    this.headers["referer"] = window.location.origin;
    this.headers[":path"] = window.location.pathname;
    this.headers[":method"] = "POST";
  }
}
